import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import Modal from '../modal';
import { Desktop, Mobile } from '../../app-responsive';
import { EMAIL_ADDRESS_ENTERED_TEXT } from '../../app-constants';
import DeletablePill from '../deletable-pill/deletable-pill';
import TextField from '../form/text-field/text-field';
import { customStylesDesktop, customStylesMobile } from '../business-case-delete-modal/modal-styles-config';

class ShareReportModal extends Component {
  constructor(props) {
    super(props);
    this.emailFormRef = React.createRef();
    this.state = {
      emailList: [],
      emailAddress: '',
      showThankYou: false,
      invalidEmailAddress: false,
      alreadyAddedEmailAddress: false,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      emailTripReportIsSending,
      showGenericErrorModal,
    } = this.props;
    if (prevProps.emailTripReportIsSending === false && emailTripReportIsSending === true) {
      this.showThankYouSection();
    }
    if (prevProps.showGenericErrorModal === false && showGenericErrorModal === true) {
      this.onCloseDialogBox();
    }
  }

  onCloseDialogBox = () => {
    this.setState({ showThankYou: false });
    const { closeModal } = this.props;
    closeModal();
  }

  onDeletePill = (pillContent) => {
    const newEmailList = this.state.emailList.filter(email => email !== pillContent);
    this.setState({ emailList: newEmailList });
  };

  onAddItem = (event) => {
    event.preventDefault();
    this.validateAndAddEmail();
  };

  onSendEmail = (event) => {
    event.preventDefault();
    const { onSendEmail } = this.props;
    onSendEmail(this.state.emailList);
  };

  onClearAll = (event) => {
    event.preventDefault();
    this.setState({ emailList: [] });
  };

  onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (this.state.emailAddress.length > 0) {
        this.validateAndAddEmail();
      }
    }
  };

  handleOnChangeEmailText = (event) => {
    this.setState({ emailAddress: event.target.value });
  };

  handleOnBlurEmailText = (event) => {
    this.setState({ emailAddress: event.target.value, validateForm: true });
  };

  validateAndAddEmail = () => {
    if (this.emailFormRef.current.checkValidity() === false) {
      this.setState({ invalidEmailAddress: true });
    } else if (this.state.emailList.includes(this.state.emailAddress)) {
      this.setState({ alreadyAddedEmailAddress: true });
    } else {
      this.setState({
        emailList: [...this.state.emailList, this.state.emailAddress],
        emailAddress: '',
        invalidEmailAddress: false,
        alreadyAddedEmailAddress: false });
    }
  };

  showThankYouSection = () => {
    this.setState({ showThankYou: true, emailList: [], alreadyAddedEmailAddress: false });
  }

  render() {
    const { modalIsOpen } = this.props;
    const desktopModalStyles = { content: { ...customStylesDesktop.content, width: '530px' } };

    const emailAddressList = this.state.emailList.map((email, emailIndex) => (
      <DeletablePill
        deletePill={this.onDeletePill}
        pillContent={email}
        key={emailIndex.toString()}
      />
    ));

    const {
      shareReport,
      clearAllButtonText,
      emailTripReportIsSending,
    } = this.props;

    const {
      headingText,
      description,
      emailLabelText,
      addEmailButtonText,
      sendEmailButtonText,
      thankYouHeading,
      thankYouDescription,
      errorEmailText,
    } = shareReport;

    const modalContent = customStyles => (
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={this.onCloseDialogBox}
        style={customStyles}
      >
        <div className="events share-report-modal text-center">
          <form ref={this.emailFormRef} noValidate>
            {this.state.showThankYou && !emailTripReportIsSending ? (
              <React.Fragment>
                <h3 className="thankyou-heading">{thankYouHeading}</h3>
                <p className="thankyou-description">{thankYouDescription}</p>
              </React.Fragment>
            ) : (
              <div className="email-section">
                <h3 className="share-heading">{renderHTML(headingText)}</h3>
                <p className="share-description">{renderHTML(description)}</p>
                <TextField
                  label={emailLabelText}
                  type="email"
                  id="share-email-txt"
                  placeholder="Email"
                  value={this.state.emailAddress}
                  onChange={this.handleOnChangeEmailText}
                  onBlur={this.handleOnBlurEmailText}
                  onKeyDown={this.onKeyDown}
                  disabled={this.state.emailList.length === 10 || emailTripReportIsSending}
                />
                <div className={this.state.invalidEmailAddress ? 'error-email text-left' : 'd-none'}>
                  <span><i className="td-icon icon-information" /></span>
                  <span className="error-email-text">{errorEmailText}</span>
                </div>
                <div className={this.state.alreadyAddedEmailAddress ? 'error-email text-left' : 'd-none'}>
                  <span><i className="td-icon icon-information" /></span>
                  <span className="error-email-text">{EMAIL_ADDRESS_ENTERED_TEXT}</span>
                </div>
                {emailAddressList.length > 0 &&
                <React.Fragment>
                  <div className="text-left">
                    {emailAddressList}
                  </div>
                  <div className="text-right">
                    <button
                      className="button mt-4 clear"
                      onClick={this.onClearAll}
                    >{clearAllButtonText}</button>
                  </div>
                </React.Fragment>
                }
                <div className="text-right">
                  <button
                    className="button mt-4 primary"
                    onClick={this.onAddItem}
                    disabled={this.state.emailAddress.length === 0 || this.state.emailList.length === 10}
                  >{addEmailButtonText}</button>
                </div>
                <div className="text-right">
                  <button
                    className={`button mt-4 do-business ${emailTripReportIsSending ? 'loading' : ''}`}
                    onClick={this.onSendEmail}
                    disabled={emailAddressList.length === 0}
                  >{sendEmailButtonText}</button>
                </div>
              </div>
            )}
          </form>
        </div>
      </Modal>
    );
    return (
      <React.Fragment>
        <Mobile>
          {modalContent(customStylesMobile)}
        </Mobile>
        <Desktop>
          {modalContent(desktopModalStyles)}
        </Desktop>
      </React.Fragment>
    );
  }
}

export default ShareReportModal;
